import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, Form, FormGroup } from 'reactstrap';
import { Button } from '@shoflo/polymer';
import { TemplateItem } from '@shoflo/polymer';
import { shouldHaveFeature } from '@studio/feature.flags';
import { createFromTemplate } from '@shoflo/studio-redux/actions';
import { selectLastMediaSource } from '@shoflo/studio-redux/selectors';
import { useCommonPageActionsApi } from '@studio/metrics';

import { MEDIA_PICKER } from 'constants/Modal';
import { useModal } from 'hooks';
import {
  StyledCloseButton,
  StyledModalHeader,
  StyledJustifyRight,
  StyledWrapper,
} from './MediaPicker.styled';

function MediaPicker() {
  const dispatch = useDispatch();
  const { stockContentUsed } = useCommonPageActionsApi();

  const [templateName, setTemplateName] = useState('');
  const { isOpen, clear } = useModal(MEDIA_PICKER);
  const isAddButtonDisabled = !templateName;
  const { order: lastMediaOrder = 0 } = useSelector(selectLastMediaSource);
  const { templates: templateMedia, isLoading } = useSelector(
    ({ templates }) => templates
  );

  function handleChange(e) {
    const { value } = e.target;
    setTemplateName(value);
  }

  function handleAdd(e) {
    e.preventDefault();
    // using template name. get the object and send object
    const selectedTemplate = templateMedia.find(
      (template) =>
        template.key === templateName || template.name === templateName
    );

    onSelectTemplate({
      ...selectedTemplate,
      isEventTemplate: false,
      media: null,
    });

    stockContentUsed({
      templateName,
    });
  }

  function onSelectTemplate(template) {
    const payload = {
      _id: template._id,
      title: template.name || template.key,
      order: lastMediaOrder + 1,
      value: { eventDocId: template._id, url: template.url },
    };

    dispatch(
      createFromTemplate({
        ...payload,
        type: 'media',
        value: template.value,
        isEventTemplate: template.isEventTemplate,
      })
    );

    clear();
  }

  const wrapperId = 'template-chooser-container';
  const containerElementSelector = `#${wrapperId}`;

  const showStockMediaTitle = shouldHaveFeature('studio.stockMediaTitles');
  function getMediaTitle(item) {
    // For the stock content modal templates, since the key doesn't exist, item.name is used to generate the title.
    const title = (
      item.name ? item.name : item.key.replace(/.*\//, '')
    ).replace(/\.[^/.]+$/, '');
    return showStockMediaTitle ? title : '';
  }

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      toggle={clear}
      data-testid="media-template-chooser-modal"
    >
      <StyledModalHeader>
        Add stock content
        <p>
          Take your presentation to the next level by adding animations,
          countdowns, and more.
        </p>
      </StyledModalHeader>
      <ModalBody>
        <StyledWrapper id={wrapperId}>
          {!isLoading
            ? templateMedia.map((item, index) => (
                <TemplateItem
                  item={item}
                  index={index}
                  key={index}
                  title={getMediaTitle(item)}
                  handleChange={handleChange}
                  containerElementSelector={containerElementSelector}
                />
              ))
            : null}
        </StyledWrapper>

        <Form data-testid="templateChooserForm" onSubmit={handleAdd}>
          <FormGroup>
            <div className="float-end" style={{ display: 'flex' }}>
              <Button
                data-testid="chooseTemplate"
                disabled={isAddButtonDisabled}
              >
                Save
              </Button>

              <StyledJustifyRight>
                <StyledCloseButton
                  data-testid="closeButton"
                  color="light"
                  variant="outlined"
                  onClick={(e) => {
                    e.preventDefault();
                    clear();
                  }}
                >
                  Close
                </StyledCloseButton>
              </StyledJustifyRight>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
}

export default MediaPicker;
